import JSONAPIClient from '../JSONAPIClient'

JSONAPIClient.define('payment_intent', {
  client_secret: '',
  payment_task_id: '',
  status: '',
})
